import { defineMessages } from 'react-intl';

export default defineMessages({
  left: { defaultMessage: 'Left' },
});
